export function newWppMessageNotification(payload) {
  return {
    type: '@notifications/NEW_MESSAGE_NOTIFICATION',
    payload: payload,
  };
}
